module.exports = __webpack_public_path__ + "static/media/Menu.9b8053cb.svg";